import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
// Animation
import { fadeInUpAnimation } from '../../../../@prep/animations/fade-in-up.animation';
import { fadeInRightAnimation } from '../../../../@prep/animations/fade-in-right.animation';
// Browser Fingerprint to generate Unique ID
import Fingerprint from 'fingerprintjs2';
// Services
import { PlatformUserService } from '../service/platform-user.service';
import { PlatformGlobalService } from '../../../layout/service/platform-global.service';
import { Title } from '@angular/platform-browser';
// Language Selector
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LoginTextDataEN } from '../auth-multi-lang/en-US';
import { LoginTextDataES } from '../auth-multi-lang/es-EU';
import { LoginTextDataIT } from '../auth-multi-lang/it-IT';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'prep-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [PlatformUserService, PlatformGlobalService],
  animations: [fadeInUpAnimation, fadeInRightAnimation],
})
export class LoginComponent implements OnInit {
  // User Login
  UserLoginFormGroup: FormGroup;
  // To extract device unique ID
  resultFingerPrint: any;

  is_loading = false; // Loading spinner flag
  inputType = 'password'; // Password input type
  visible = false;

  // SSOFlow flag to check if the flow is SSO or not
  readonly SSOFlow  = environment.sso;
  readonly ssoLabel = environment.ssoLabel;
  readonly ssoUrl   = environment.ssoUrl;
  isPlamBeach = environment.ssoLabel === 'PALM BEACH COUNTY BOARD COUNTY COMMISSIONERS';


  // Language Selector
  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;
  // Accessibility
  @ViewChild('emailInputRef', { static: false }) emailInputRef!: ElementRef<HTMLInputElement>;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private titleService: Title,
    private route: ActivatedRoute,
    private platformuserService: PlatformUserService,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService
  ) {

    this.languageSelectorService.language$.subscribe(lang => {
      console.log('🌍 Language changed globally:', lang);
      this.selectedLang = lang;

      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = LoginTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = LoginTextDataES;
          console.log('🌍 Europe Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = LoginTextDataIT;
          console.log('🌍 Italian Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = LoginTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }

      // Dynamically replace SSO label from environment config
      if (this.SSOFlow && this.ssoLabel) {
        this.LangTextData.htmlLabel.ssoUserLogin =
          this.LangTextData.htmlLabel.ssoUserLogin.replace('COLORADO SPRINGS', this.ssoLabel);
      }
    });

    if (this.SSOFlow === true) {
      this.UserLoginFormGroup = this.fb.group({
        etaToken: '',
        id: '',
      });
    } else {
      this.UserLoginFormGroup = this.fb.group({
        username: ['', [Validators.required, Validators.email]],
        password: ['', Validators.required],
        id: '',
      });
    }
    // Generate Fingerprint for Unique ID
    this.resultFingerPrint = async () => {
      const secure = await new Promise((resolve) => {
        Fingerprint.getV18((result, components) => resolve(result));
      });
      return secure;
    };
    this.resultFingerPrint().then((result) => {
      this.resultFingerPrint = result;
      this.UserLoginFormGroup.patchValue({
        id: result,
      });
    });
    console.log('Login Form', this.UserLoginFormGroup.value);
  }

  // Accessibility Live Region
  announceMessage(message: string) {
    const region = document.getElementById('a11y-live-region');
    if (region) {
      region.textContent = '';
      setTimeout(() => region.textContent = message, 100); // trigger change detection
    }
  }

  ngOnInit() {
    this.titleService.setTitle(this.LangTextData.SEOlLabel.appTitle);
    // Check user Offline / Online
    this.platformuserService.createOnline$().subscribe((isOnline) => {
      console.log('online======', isOnline);
      if (!isOnline) {
        this.snackbar.open(
          this.LangTextData.snackbarLabels.errorInternetConnection,
          'OK THANKS',
          {
            duration: 10000,
          }
        );
      }
    });

    if (this.SSOFlow === true) {
      console.log(
        'router snap shot before condition',
        this.route.snapshot.paramMap.get('etaToken')
      );
      if (this.route.snapshot.paramMap.get('etaToken')) {
        this.UserLoginFormGroup.patchValue({
          etaToken: this.route.snapshot.paramMap.get('etaToken'),
        });
        this.is_loading = true;
        console.log('User Login SSO Mard', this.UserLoginFormGroup.value);
        this.platformuserService.ssoUser(this.UserLoginFormGroup.value).subscribe(
          (response) => {
            console.log('Response SSO USER', response);
            this.is_loading = false;
            localStorage.setItem('token', response['token']);
            this.platformGlobalService.me = response['user'];
            this.router.navigate(['dashboard']);
          },
          (error) => {
            console.log('error', error);
            if (error.status === 400) {
              this.is_loading = false;
              this.snackbar.open(this.LangTextData.snackbarLabels.errorLogin400, 'OK THANKS', {
                duration: 1500,
              });
              this.router.navigate(['/login']);
            } else if (error.status === 401) {
              this.snackbar.open(
                this.LangTextData.snackbarLabels.errorLogin401,
                'OK THANKS',
                {
                  duration: 1500,
                }
              );
              this.router.navigate(['login']);
            } else if (error.status === 417) {
              this.is_loading = false;
              console.log('error info cuncurrent user', error.error.msg);
              if (error.error.msg) {
                this.snackbar.open(error.error.msg, 'OK THANKS', {
                  duration: 10000,
                });
              }
            } else {
              this.is_loading = false;
              this.router.navigate(['login']);
            }
          }
        );
      } else {
        this.is_loading = false;
      }

    } else {
      // Login User If User already Logged In
      if (localStorage.getItem('token') && localStorage.getItem('account')) {
        this.platformGlobalService.me = JSON.parse(
          localStorage.getItem('account')
        );
        this.router.navigate(['dashboard']);
      }
      this.is_loading = false;
    }

  }



  send() {
    this.is_loading = true;
    console.log(this.UserLoginFormGroup.value);
    if (this.SSOFlow === true) {
      const link = document.createElement('a');
      link.setAttribute('href', this.ssoUrl);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.platformuserService.loginUser(this.UserLoginFormGroup.value).subscribe(
        (response) => {
          this.is_loading = false;
          localStorage.setItem('token', response['token']);
          this.platformGlobalService.me = response['user'];
          this.announceMessage(this.LangTextData.snackbarLabels.SuccessSignIn);
          this.snackbar.open(this.LangTextData.snackbarLabels.SuccessSignIn, 'OK THANKS', {
            duration: 5000
          });
          this.router.navigate(['dashboard']);
        },
        (error) => {
          console.log('error', error);
          if (error.status === 400) {
            this.is_loading = false;
            // Highlight email and password fields with mat-error
            // Set custom flags for username and password errors
            this.UserLoginFormGroup.get('username')?.setErrors({ invalid: true });
            this.UserLoginFormGroup.get('password')?.setErrors({ invalid: true });
            // Clear the errors programmatically by resetting the form
            this.UserLoginFormGroup.reset();
            this.announceMessage(this.LangTextData.snackbarLabels.errorLogin400);
            this.snackbar.open(this.LangTextData.snackbarLabels.errorLogin400, 'OK THANKS', {
              duration: 10000
            });
            this.router.navigate(['/login']);
            this.focusFirstInvalidControl();
          } else if (error.status === 401) {
            this.is_loading = false;
            this.snackbar.open(
              this.LangTextData.snackbarLabels.errorLogin401,
              'OK THANKS',
              {
                duration: 10000
              }
            );
            this.router.navigate(['login']);
            this.focusFirstInvalidControl();
          } else if (error.status === 417) {
            this.is_loading = false;
            console.log('error info cuncurrent user', error.error.msg);
            if (error.error.msg) {
              this.snackbar.open(error.error.msg, 'OK THANKS', {
                duration: 10000
              });
              this.focusFirstInvalidControl();
            }
          } else {
            this.is_loading = false;
            this.router.navigate(['login']);
            this.focusFirstInvalidControl();
          }
        }
      );
    }
    this.platformuserService.createOnline$().subscribe((isOnline) => {
      console.log('online======', isOnline);
      if (!isOnline) {
        this.snackbar.open(
          this.LangTextData.snackbarLabels.errorInternetConnection,
          'OK THANKS',
          {
            duration: 10000
          }
        );
      }
    });
  }

  // Password Toggle Visibility
  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  focusMain(event: Event): void {
    event.preventDefault();
    const main = document.getElementById('main-content');
    if (main) {
      // Make it programmatically focusable
      main.setAttribute('tabindex', '-1');
      main.focus();
    }
  }

  // Accessibility: Focus on the email input field when the component initializes
  focusFirstInvalidControl(): void {
    setTimeout(() => {
      console.log(this.emailInputRef);

      if (this.emailInputRef?.nativeElement) {
        const inputEl = this.emailInputRef.nativeElement;

        // Ensure focusable
        inputEl.focus();
        inputEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        console.log('Focused email input');
      } else {
        console.warn('emailInputRef not found');
      }
    }, 300); // enough delay to let DOM settle
  }
}
